export default __webpack_public_path__ + "8ae273da7cd9c757c4628e12096332c4.json";